import React from 'react';
import {string, object, func} from 'prop-types';
import {FormattedMessage} from 'react-intl';
import ResourceForm from 'components/forms/ResourceForm';
import components from 'components/forms/Component Sets/UnvalidatedBasicFormComponents';
import {ImageFilenameTooltip, ImageNameTooltip, ImageSourceTooltip, ImageAltAttributeTooltip, ImageLinkTooltip} from 'components/images/tooltips/image-edit-modal-tooltips';

/*
    Collects the image metadata the legacy Filestack flow always asked for
    immediately after picking a file, before any upload or crop -- see
    pages/Images/UploadOriginalEditImageModalContainer.jsx, whose "Image
    Information" modal (components/images/ImageEditModal.jsx) pops as soon
    as state.images.pendingImages is populated (pickedOriginalAction),
    independent of resource context. That container is wired to the legacy
    uploadOriginal/saveImageData epics (it creates the OriginalImage record
    itself once the form is saved) and to Redux state this native,
    single-request upload flow doesn't have (and shouldn't gain just to
    reuse one screen), so it can't be reused directly here. This is a small,
    self-contained equivalent instead: same field set, tooltips and
    validation rules as components/images/imageFormConfig.js, including
    `link` -- ImageUploadServiceImpl's @Uploader now accepts a `link`
    parameter so this field round-trips like the rest. `filename` is also
    included (unlike an earlier version of this step) -- the endpoint gained
    a `filename` param specifically so this field could round-trip.
*/
export const infoFormConfig = {
  fields: [
    {
      name: 'sponsoredType',
      type: 'hidden'
    },
    {
      name: 'filename',
      type: 'text-with-tooltip',
      required: true,
      props: {
        label: <FormattedMessage id='images.edit.filename' />,
        helpContent: <ImageFilenameTooltip />
      }
    },
    {
      name: 'name',
      type: 'text-with-tooltip',
      required: true,
      props: {
        label: <FormattedMessage id='images.edit.name' />,
        helpContent: <ImageNameTooltip />
      }
    },
    {
      name: 'source',
      type: 'text-with-tooltip',
      required: (proxy) => (proxy.currentResource.sponsoredType === 'editorial'),
      props: {
        label: <FormattedMessage id='images.edit.source' />,
        helpContent: <ImageSourceTooltip />
      }
    },
    {
      name: 'altAttribute',
      type: 'text-with-tooltip',
      required: false,
      props: {
        label: <FormattedMessage id='images.edit.altAttribute' />,
        helpContent: <ImageAltAttributeTooltip />
      }
    },
    {
      name: 'link',
      type: 'text-with-tooltip',
      props: {
        label: <FormattedMessage id='images.edit.link' />,
        helpContent: <ImageLinkTooltip />,
        validationRules: [
          {
            type: 'HyperLinkFormat'
          }
        ]
      }
    }
  ]
};

const ImageUploadInfoStep = ({formData, errors, previewUrl, onValueChanged}) => (
  <div className="db-image-upload-info-step">
    {previewUrl && (
      <img src={previewUrl} alt={formData.name} style={{maxWidth: '100%', maxHeight: 200}} />
    )}
    <ResourceForm
      resource={formData}
      config={infoFormConfig}
      components={components}
      errors={errors}
      onValueChanged={onValueChanged}
      onValidationError={console.log} />
  </div>
);

ImageUploadInfoStep.propTypes = {
  formData: object.isRequired,
  errors: object,
  previewUrl: string,
  onValueChanged: func.isRequired
};

ImageUploadInfoStep.defaultProps = {
  errors: {}
};

export default ImageUploadInfoStep;



// WEBPACK FOOTER //
// ./public/components/images/ImageUploadInfoStep.jsx